import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isBooleanRawvalue',
    standalone: false
})
export class IsBooleanRawvaluePipe implements PipeTransform {

  transform(value: string): boolean {
    return ['true', 'vero', 'si', 'sì', 'false', 'falso', 'no'].includes(value.toLowerCase())
  }

}


@Pipe({
    name: 'toBooleanRawvalue',
    standalone: false
})
export class ToBooleanRawvaluePipe implements PipeTransform {

  transform(value: string): boolean | undefined {
    if (['true', 'vero', 'si', 'sì'].includes(value.toLowerCase())) return true
    else if (['false', 'falso', 'no'].includes(value.toLowerCase())) return false
    else return undefined
  }

}